import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

export const TOKEN_KEY = "ivcasa_admin_token";
http.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

const eur = new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 });

export const formatPrice = (l) =>
  l?.prezzo ? `${eur.format(l.prezzo)}${l.contratto === "Affitto" ? " /mese" : ""}` : "Trattativa riservata";

export const prettyTitle = (t = "") => (t ? t.charAt(0) + t.slice(1).toLowerCase() : "");

export const imgUrl = (u) => u;

export const coverOf = (l) => imgUrl((Array.isArray(l?.immagini) && l.immagini[0]) || "/img/ivcasa_footer.jpg");
